import { render } from "./UserEditModal.vue?vue&type=template&id=58b86b3c&scoped=true"
import script from "./UserEditModal.vue?vue&type=script&lang=js"
export * from "./UserEditModal.vue?vue&type=script&lang=js"

import "./UserEditModal.vue?vue&type=style&index=0&id=58b86b3c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b86b3c"]])

export default __exports__